"use client";

import React from "react";
import { Phone } from "lucide-react";
import { motion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function BasementCtaBand() {
  return <section id="basementremodelctaband" data-nav="dark" className="relative overflow-hidden bg-secondary text-secondary-foreground py-16 sm:py-20 lg:py-24 border-y border-border/15">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        ease: [0.16, 1, 0.3, 1]
      }} className="mx-auto max-w-3xl text-center">
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-secondary-foreground">
            Ready to remodel your Brookhaven basement?
          </h2>

          <p className="mt-4 sm:mt-6 text-base sm:text-lg text-secondary-foreground/80 leading-relaxed">
            From custom home theaters and guest suites to luxury wet bars, we deliver tailored architecture and transparent milestones for your home.
          </p>

          <div className="mt-8 sm:mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button asChild size="lg" className="w-full sm:w-auto bg-primary text-primary-foreground font-medium shadow-md hover:bg-primary/90">
              <Link to="/ContactRequestAnEstimatePage">
                Get a Free Estimate
              </Link>
            </Button>

            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto border-secondary-foreground/20 bg-secondary/60 text-secondary-foreground hover:bg-secondary hover:text-secondary-foreground">
              <a href="tel:+14708479076">
                <Phone className="size-4 mr-2" aria-hidden="true" />
                Call (470) 847-9076
              </a>
            </Button>
          </div>
        </motion.div>
      </div>
    </section>;
}